import api from 'Api'
import { SET_MESSAGE } from '../components/utils'
import moment from 'moment'

const GET_SCAN_SCHEDULES = '/scan-schedule/organization/'
const ADD_REMOVE_SCAN_SCHEDULE = '/scan-schedule'

const state = {
  scans: [],
  isLoadingScans: false
}

const actions = {
  async getScans ({ commit }, organizationId) {
    if (!organizationId) return
    commit('SET_SCANS_LOADING', true)
    let response
    try {
      response = await api().get(GET_SCAN_SCHEDULES + organizationId)
      response.data && response.data.map(s => {
        s.scan_time = moment.utc(s.scan_time, 'hh:mm A').local().format('hh:mm A')
      })
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    commit('SET_SCANS_LOADING', false)
    commit('GET_SCANS', response.data || [])
  },
  async addScan ({ commit }, payload) {
    if (!payload.organization_id) return
    const requestMethod = payload.entity_id ? 'put' : 'post'
    commit('SET_SCANS_LOADING', true)

    let payloadDataBeforeUpdate = null
    if (payload.entity_id) {
      const index = state.scans.findIndex(s => s.entity_id === payload.entity_id)
      payloadDataBeforeUpdate = Object.assign({}, state.scans[index])
    }

    const payObject = Object.assign({}, payload)
    payObject.updatedScan = true
    if (payObject.scan_time) { payObject.scan_time = moment.utc(payObject.scan_time, 'hh:mm A').local().format('hh:mm A') }
    commit('ADD_SCAN', { payload: payObject, requestMethod })

    let response
    try {
      response = await api()[requestMethod](ADD_REMOVE_SCAN_SCHEDULE, payload)
      if (response.data.scan_time) { response.data.scan_time = moment.utc(response.data.scan_time, 'hh:mm A').local().format('hh:mm A') }
      if (response.data.error) {
        commit('ADD_SCAN', { payload: payloadDataBeforeUpdate, requestMethod, responseError: true })
        SET_MESSAGE({ type: 'error', message: response.data.error })
      } else {
        commit('ADD_SCAN', { payload: response.data, requestMethod })
        SET_MESSAGE({ type: 'success', message: 'Scan is added successfully' })
      }
    } catch (e) {
      commit('ADD_SCAN', { payload: payloadDataBeforeUpdate, requestMethod, responseError: true })
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    commit('SET_SCANS_LOADING', false)
  },
  async deleteScan ({ commit }, entityId) {
    commit('DELETE_SCAN', entityId)
    let response
    try {
      response = await api().delete(`${ADD_REMOVE_SCAN_SCHEDULE}/${entityId}`)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
  }
}

const mutations = {
  SET_SCANS_LOADING (state, isLoading) {
    state.isLoadingScans = isLoading
  },
  SET_COLLECTOR_PRINCIPLES (state, collectorPrinciples) {
    state.collectorPrinciples.push(...collectorPrinciples)
  },
  GET_SCANS (state, payload) {
    state.scans = payload
  },
  ADD_SCAN (state, { payload, requestMethod, responseError }) {
    if (requestMethod === 'post' && payload && payload.updatedScan) {
      state.scans.unshift(payload)
      return
    }

    if (responseError && requestMethod == 'post') {
      state.scans.splice(index, 1)
    } else {
      let index = state.scans.findIndex(s => s.updatedScan && s.collector_id == payload.collector_id)
      if (index == -1) {
        index = state.scans.findIndex(s => s.entity_id === payload.entity_id)
      }
      state.scans.splice(index, 1, payload)
    }
  },
  DELETE_SCAN (state, entityId) {
    state.scans = state.scans.filter(s => s.entity_id !== entityId)
  },
  RESET_SCANS (state) {
    state.scans = []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  name: 'schedulingServices'
}
